import React, { useState, useEffect, useRef } from "react";
import { io } from "socket.io-client";
import axios from "axios";
import "./ChatApp.css";
import AI from "../assets/AI.png";
const apiUrl = process.env.REACT_APP_API_BASE_URL;
const SOCKET_URL = `${apiUrl}`;
const API_URL = `${apiUrl}/api/chat`;

const ChatApp = () => {
  const [socket, setSocket] = useState(null);
  const [messages, setMessages] = useState([]);
  const [inputMessage, setInputMessage] = useState("");
  const [isConnected, setIsConnected] = useState(false);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [userId, setUserId] = useState("");
  const [hasUsername, setHasUsername] = useState(false);
  const messagesEndRef = useRef(null);
  const [userbox, setUserbox] = useState(false);

  useEffect(() => {
    const savedUserId = localStorage.getItem("chatUserId");
    if (savedUserId) {
      setUserId(savedUserId);
      setHasUsername(true);
    }
  }, []);

  useEffect(() => {
    const newSocket = io(SOCKET_URL);
    setSocket(newSocket);

    newSocket.on("connect", () => {
      setIsConnected(true);
      console.log("Connected to server");

      const savedUserId = localStorage.getItem("chatUserId");
      if (savedUserId) {
        console.log("Re-emitting userConnected with:", savedUserId);
        newSocket.emit("userConnected", savedUserId);
      }
    });

    return () => {
      newSocket.disconnect();
    };
  }, []);

  useEffect(() => {
    if (!socket) return;

    socket.on("adminMessage", (message) => {
      console.log("Received admin message:", message);
      setMessages((prev) => [...prev, { sender: "Admin", text: message.message }]);
    });

    return () => {
      socket.off("adminMessage");
    };
  }, [socket]);

  useEffect(() => {
    const fetchMessages = async () => {
      if (userId) {
        try {
          const chatResponse = await axios.get(`${API_URL}/${userId}`);
          setMessages(chatResponse.data.messages);
          console.log("Messages loaded from server");
        } catch (error) {
          console.error("Failed to load messages:", error);
        }
      }
    };

    fetchMessages();
  }, [userId]);

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  useEffect(() => {
    if (socket && isConnected && userId) {
      socket.emit("userConnected", userId);
      console.log("User re-registered after reconnect:", userId);
    }
  }, [socket, isConnected, userId]);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleUsernameSubmit = async (e) => {
    e.preventDefault();
    if (username.trim() && email.trim()) {
      try {
        const response = await axios.post(`${API_URL}/start`, { name: username, email });
        console.log("User ID from server:", response.data.userId);
        setUserId(response.data.userId);
        localStorage.setItem("chatUserId", response.data.userId);

        socket.emit("userConnected", response.data.userId);

        const chatResponse = await axios.get(`${API_URL}/${response.data.userId}`);
        console.log("Chat Data:", chatResponse.data);
        setMessages(chatResponse.data.messages);

        setHasUsername(true);
      } catch (error) {
        console.error("Error starting chat:", error);
      }
    }
  };

  const sendMessage = async (e) => {
    e.preventDefault();
    if (!inputMessage.trim() || !userId) {
      console.error("Error: Message text or userId is missing!");
      return;
    }

    const messageData = {
      userId: userId,
      text: inputMessage,
    };

    try {
      const response = await axios.post(`${API_URL}/send`, messageData);
      console.log("Message sent:", response.data);

      socket.emit("sendMessage", messageData);
      setMessages((prev) => [...prev, { sender: userId, text: inputMessage }]); // <-- userId used here
      setInputMessage("");
    } catch (error) {
      console.error("Error sending message:", error.response?.data || error.message);
    }
  };

  const toggleChatApp = () => {
    setUserbox(true);
  };

  const handleOuterClick = () => {
    setHasUsername(false);
    setUserbox(false);
  };

  const handleInnerClick = (event) => {
    event.stopPropagation();
  };

  return (
    <>
      {userbox && (
        <div className="username-container chat1" onClick={handleOuterClick}>
          <form onSubmit={handleUsernameSubmit} className="username-form" onClick={handleInnerClick}>
            <h2 className="chath2">Enter your details</h2>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Username"
              className="username-input"
            />
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              className="username-input"
            />
            <button type="submit" className="username-button">Join Chat</button>
          </form>
        </div>
      )}

      {/* <div className="chatApp" onClick={toggleChatApp}>
        <img src={AI} alt="chatBot" />
      </div> */}

      {hasUsername && (
        <div className="chat1" onClick={handleOuterClick}>
          <div className="chat-container" onClick={handleInnerClick}>
            <div className="chat-header">
              <h2>Chat with Admin</h2>
              <div className="connection-status">{isConnected ? "🟢 Connected" : "🔴 Disconnected"}</div>
            </div>

            <div className="messages-container">
              {userId && messages.map((message, index) => {
                const isUser = message.sender === userId || message.sender === "You";
                return (
                  <div
                    key={index}
                    className={`message ${isUser ? "user-message" : "admin-message"}`}
                  >
                    <div className="message-sender">{isUser ? "You" : message.sender}</div>
                    <div className="message-content">{message.text}</div>
                  </div>
                );
              })}
              <div ref={messagesEndRef} />
            </div>

            <form onSubmit={sendMessage} className="input-container">
              <input
                type="text"
                value={inputMessage}
                onChange={(e) => setInputMessage(e.target.value)}
                placeholder="Type your message..."
                className="message-input"
              />
              <button type="submit" className="send-button">Send</button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default ChatApp;
